import * as React from 'react';
import DefaultButton from '../default-button/default-button';
import classnames from 'classnames';
import { IMultiSelectClosedPropsDerivedFromItemsList } from './make-multi-select-in-popover';
import {makeFiltersMultiSelect} from './make-filters-multi-select';

type IMultiSelectButtonProps = IMultiSelectClosedPropsDerivedFromItemsList & {
    text: string;
    className?: string;
    onClick?: () => void;
};

/**
 * Render DefaultButton, with label, selectable through the SingleSelectList rendered in popover
 * change button look and feel based on popover being shown/hidden
 */
const FiltersMultiSelectButton = makeFiltersMultiSelect(
    React.forwardRef((props: IMultiSelectButtonProps, ref: React.Ref<HTMLInputElement>) => {
        const { text, isOpen, onClick, className } = props;

        return <DefaultButton
            text={text}
            ref={ref}
            onClick={() => isOpen && onClick && onClick()}
            className={classnames(className, {
                'active': isOpen
            })} />;
    })
);

export { FiltersMultiSelectButton, IMultiSelectButtonProps };
